import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { AuthoriseMerchantResponseModel, ICPLAuthGoCardlessClient } from "./api/cplauthapi/CPLAuthAPI";

export interface IGoCardlessService {
  authoriseMerchant(): Promise<AuthoriseMerchantResponseModel>;
  revokeAccessToken(): Promise<void>;
}

@injectable()
export class GoCardlessService implements IGoCardlessService {
  @inject(SERVICE_TYPES.CPLAuthGoCardlessClient) cplAuthGoCardlessClient!: ICPLAuthGoCardlessClient;

  async authoriseMerchant(): Promise<AuthoriseMerchantResponseModel> {
    return this.cplAuthGoCardlessClient.authoriseMerchant();
  }

  async revokeAccessToken(): Promise<void> {
    return this.cplAuthGoCardlessClient.revokeAccessToken();
  }
}
